// ============================================================================
// CANCUN100 — tema.js  (Bloque 25: radios, altos y estilos en línea · APP 2/20 Fase A: el COLOR vive solo en temaEquipo.js)
// ----------------------------------------------------------------------------
// Todo lo que sea radio, alto, sombra, fuente o color de equipo se lee de aquí (JS) o de las variables
// CSS equivalentes en styles/aurelia-tokens.css (--au-radius-*, --au-shadow-card, --au-font-text). Colores: temaEquipo.js (paletaEquipo / COLOR_EQUIPO / --eq-*).
// Nada hardcodeado en componentes. Los PDF descargables (src/pdf) tienen su propio estilo y no entran aquí.
// ============================================================================

// ── Radios: casi rectangulares, nada de píldoras ──
export const RADIO_TARJETA = 12;  // tarjetas, modales, paneles, dropdowns, panel de la campana
export const RADIO = 8;           // botones, campos, selects, textareas, chips/subpestañas, toggles segmentados
export const RADIO_INSIGNIA = 6;  // insignias (ADMIN, Activo, INE, NAL…)
export const RADIO_AVATAR = 8;    // avatar / ícono C1
// Únicas excepciones redondas: puntos de estado de 8 px y el número de la campana.

// ── Alturas compactas ──
export const ALTO_BOTON = 40;     // botón principal / secundario
export const ALTO_CAMPO = 40;     // campo de texto / select
// APP 2/20 Fase A: fuera ALTO_CHICO, ALTO_CHIP, ALTO_SEG, PAD_BOTON, EQUIPO, TURQUESA_TT, ACENTOS, estiloAcento, areaTexto, botonChico (0 usos; el color de equipo está en temaEquipo.COLOR_EQUIPO).

// ── Sombra única, borde único, una sola fuente ──
export const SOMBRA = 'var(--au-shadow-card)';   // claro 0 4px 16px rgba(0,0,0,.08) · oscuro .35
export const FUENTE = 'var(--au-font-text)';     // DM Sans en toda la app (títulos incluidos)

// ── Escala tipográfica ──
export const TIPO = {
  titulo:    { fontSize: 22, fontWeight: 700 },
  subtitulo: { fontSize: 14, fontWeight: 700 },
  etiqueta:  { fontSize: 14, fontWeight: 600 },
  texto:     { fontSize: 14, fontWeight: 400 },
  insignia:  { fontSize: 12, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.06em' },
};

// ── Estilos listos para usar en línea ──
// Campo de formulario: fondo = fondo de la app, borde 1 px, 40 px de alto.
export const campo = (C) => ({
  width: '100%', height: ALTO_CAMPO, boxSizing: 'border-box', background: C.dark, border: `1px solid ${C.border}`,
  borderRadius: RADIO, padding: '0 14px', color: C.text, fontSize: 14, fontFamily: FUENTE, outline: 'none',
});
// Etiqueta de campo (siempre arriba del campo, 6 px de separación).
export const etiqueta = (C) => ({ ...TIPO.etiqueta, color: C.muted, marginBottom: 6, display: 'block' });
// Insignia.
export const insignia = (color) => ({ ...TIPO.insignia, display: 'inline-block', padding: '2px 8px', borderRadius: RADIO_INSIGNIA, color, background: `${color}1f`, border: `1px solid ${color}55` });
